import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const QUICK_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/solutions', label: 'Solutions' },
  { to: '/contract-vehicles', label: 'Contract Vehicles' },
  { to: '/opportunities', label: 'Join our Team' },
  { to: '/news', label: 'News' },
  { to: '/contact', label: 'Contact Us' },
];

export default function NotFound() {
  useEffect(() => {
    document.title = 'Page Not Found | Inalab';
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="notfound-wrapper" aria-labelledby="notfound-heading">
      <p className="notfound-code">404</p>
      <h1 className="notfound-heading" id="notfound-heading">This page could not be found</h1>
      <p className="notfound-text">
        The page you are looking for may have moved or no longer exists. Try one of the links
        below, or head back to our homepage.
      </p>

      <div className="notfound-links">
        {QUICK_LINKS.map(link => (
          <Link key={link.to} to={link.to} className="notfound-link">
            {link.label}
          </Link>
        ))}
      </div>

      <Link to="/" className="notfound-home-btn">Back to Home</Link>
    </main>
  );
}
